import { createFileRoute, useParams } from '@tanstack/react-router';

import { QuizEditPage } from '@/views/admin/courses/quizzes/quiz-edit-page.tsx';

// 深层 survey / 自评编辑器——复用 QuizEditPage，根据服务器返回的
// quiz `kind` 分支。`assessments_` 末尾的 `_` 脱离
// assessments 列表路由（终端，无 <Outlet/>）的嵌套，挂载在
// 课程详情布局的 <Outlet/> 下。URL 保留 `assessments` 段使
// Assessments tab 保持高亮。
export const Route = createFileRoute('/admin/courses_/$id/assessments_/$quizId/edit')({
  component: AssessmentEditRoute,
});

function AssessmentEditRoute() {
  const { id, quizId } = useParams({ from: '/admin/courses_/$id/assessments_/$quizId/edit' });
  return <QuizEditPage courseId={id} quizId={quizId} />;
}
